import React from 'react';
import { BrainIcon } from 'lucide-react';
export function UMPSection() {
  return <section className="py-16 bg-green-50" data-id="element-406">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-407">
        <div className="text-center mb-12" data-id="element-408">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-409">
            LA VERDADERA RAZÓN DE TU ESTRÉS
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-410">
            Nunca has tenido las herramientas adecuadas para manejar la presión
            diaria.
          </p>
        </div>
        <div className="mt-10" data-id="element-411">
          <div className="text-center mb-10" data-id="element-412">
            <p className="text-xl font-medium text-gray-900" data-id="element-413">
              Pero ahora puedes desarrollar algo que casi nadie entrena:
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-414">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-415">
              <div className="flex items-center mb-4" data-id="element-416">
                <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-417">
                  <svg className="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-418">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-419" />
                  </svg>
                </div>
                <h3 className="font-medium text-gray-900" data-id="element-420">
                  Respiración consciente
                </h3>
              </div>
              <p className="text-gray-600 text-sm" data-id="element-421">
                Técnicas de respiración que activan tu sistema parasimpático y
                reducen la ansiedad en segundos.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-422">
              <div className="flex items-center mb-4" data-id="element-423">
                <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-424">
                  <svg className="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-425">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-426" />
                  </svg>
                </div>
                <h3 className="font-medium text-gray-900" data-id="element-427">Anclaje sensorial</h3>
              </div>
              <p className="text-gray-600 text-sm" data-id="element-428">
                Métodos para frenar pensamientos acelerados y volver al momento
                presente en segundos.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-429">
              <div className="flex items-center mb-4" data-id="element-430">
                <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-431">
                  <svg className="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-432">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-433" />
                  </svg>
                </div>
                <h3 className="font-medium text-gray-900" data-id="element-434">Rituales de calma</h3>
              </div>
              <p className="text-gray-600 text-sm" data-id="element-435">
                Protocolos rápidos para activar tu estado de calma incluso en
                los momentos más estresantes.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-436">
              <div className="flex items-center mb-4" data-id="element-437">
                <div className="bg-green-100 rounded-full p-2 mr-3" data-id="element-438">
                  <svg className="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-439">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-440" />
                  </svg>
                </div>
                <h3 className="font-medium text-gray-900" data-id="element-441">Descanso profundo</h3>
              </div>
              <p className="text-gray-600 text-sm" data-id="element-442">
                Técnicas para desconectar tu mente y lograr un sueño reparador
                sin medicamentos.
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-443">
            <p className="text-xl font-medium text-gray-900" data-id="element-444">
              Mientras otros improvisan, tú tendrás un sistema.
            </p>
            <p className="mt-2 text-lg text-gray-600" data-id="element-445">
              Y por primera vez, ese sistema está en tus manos.
            </p>
            <div className="mt-8" data-id="element-446">
              <a href="https://clickylee.com/products/kit-de-emergencias-anti-stress-5-bonos-gratis?variant=46954999415019" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors" data-id="element-447">
                Quiero mi Kit Anti-Estrés Ahora
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}